var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2048 2048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1024 2048q141 0 272 -36.5t244.5 -103.5t207 -160.5t160.5 -207t103.5 -244.5t36.5 -272t-36.5 -272t-103.5 -244.5t-160.5 -207t-207 -160.5t-244.5 -103.5t-272 -36.5t-272 36.5t-244.5 103.5t-207 160.5t-160.5 207t-103.5 244.5t-36.5 272t36.5 272t103.5 244.5 t160.5 207t207 160.5t244.5 103.5t272 36.5zM1024 128q124 0 238.5 32t214 90.5t181 140t140 181t90.5 214t32 238.5t-32 238.5t-90.5 214t-140 181t-181 140t-214 90.5t-238.5 32t-238.5 -32t-214 -90.5t-181 -140t-140 -181t-90.5 -214t-32 -238.5t32 -238.5t90.5 -214 t140 -181t181 -140t214 -90.5t238.5 -32zM1152 1408h128v-768h-128v768zM768 1408h128v-768h-128v768z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHold);
export default __webpack_public_path__ + "static/media/hold.23e9ed36.svg";
export { ForwardRef as ReactComponent };